import React, { useContext, useState } from 'react';
import onelps from '../../api';
import { cookieExist, setCookie } from '../browser-cookies';
import { AppContext } from '../../Store';
import { NicknameFieldContext } from '../../state-management/contexts/regform-fields/nickname-field-context';
import { PasswordFieldContext } from '../../state-management/contexts/regform-fields/password-field-context';
import { EmailFieldContext } from '../../state-management/contexts/regform-fields/email-field-context';
import { TermsCheckboxContext } from '../../state-management/contexts/regform-checkboxes/terms-checkbox-context';
import { registerWithAllFields } from '../form-registrations';
import { COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE } from '../cookie-overlay';
import {
	isValidationErrorResponse,
	handleNicknameValidity, handlePasswordValidity,
} from './common';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ERROR_CODE } from '../server-messages';

export const withTwoStepValidation = function(Component) {
	const EnhancedComponent = function({ ...props }) {
		const [state, dispatch] = useContext(AppContext);
		const [nicknameState, nicknameDispatch] = useContext(NicknameFieldContext);
		const [passwordState, passwordDispatch] = useContext(PasswordFieldContext);
		const [emailState, emailDispatch] = useContext(EmailFieldContext);
		const [termsState, termsDispatch] = useContext(TermsCheckboxContext);

		const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

		const { t } = useTranslation('translation');

		const handleContinueClick = async (e) => {
			e.preventDefault();
			try {
				const validateRequest = {
					nickname: nicknameState.value,
					password: passwordState.value,
				};
				const validationResult = await onelps.actions.validate(validateRequest, state.locale);

				if (isValidationErrorResponse(validationResult)) {
					handleNicknameValidity(validationResult.errors.nickname, nicknameDispatch);
					handlePasswordValidity(validationResult.errors.password, passwordDispatch);

				} else {
					dispatch && dispatch({ type: 'INCREASE_CURRENT_STEP' });
				}
			} catch (e) {
				dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(DEFAULT_ERROR_CODE) });
				dispatch({ type: 'SHOW_SERVER_ERROR' });
			}
		};

		const handlePlayClick = async (e) => {
			e ? e.preventDefault() : null;

			setShowLoadingIndicator(true);

			if (!emailState.value) {
				emailDispatch({ type: 'SET_EMAIL_ERROR', payload: t('form.email.errorMessages.errorMessageEmpty') });
				emailDispatch({ type: 'SHOW_EMAIL_ERROR' });
				setShowLoadingIndicator(false);
			}

			if (!termsState.value) {
				termsDispatch({ type: 'SET_TC_ERROR', payload: t('form.terms.errorMessages.errorMessageEmpty') });
				termsDispatch({ type: 'SHOW_TC_ERROR' });
				setShowLoadingIndicator(false);
			}

			if (emailState.value && termsState.value &&
				!nicknameState.error.message &&
				!passwordState.error.message &&
				!emailState.error.message &&
				!termsState.error.message
			) {
				nicknameDispatch({ type: 'HIDE_NICKNAME_ERROR' });
				passwordDispatch({ type: 'HIDE_PASSWORD_ERROR' });
				emailDispatch({ type: 'HIDE_EMAIL_ERROR' });
				termsDispatch({ type: 'HIDE_TC_ERROR' });

				if (!cookieExist(COOKIE_NOTIFICATION_NAME)) {
					setCookie(COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE);
					dispatch({ type: 'HIDE_COOKIE_OVERLAY' });
					dispatch({ type: 'MARK_TRACKING_EXECUTED' });
				}

				await registerWithAllFields(
					state.locale, dispatch, nicknameDispatch, passwordDispatch, emailDispatch, termsDispatch,
					nicknameState.value, passwordState.value, emailState.value, termsState.value,
					state.thirdPartyTrackingAccepted, state.race,
				);
			}
			else {
				setShowLoadingIndicator(false);
			}
		};

		return (
			<Component
				{...props}
				handleContinueClick={handleContinueClick}
				handlePlayClick={handlePlayClick}
				currentStep={state && state.currentStep}
				showLoadingIndicator={showLoadingIndicator}
			/>
		);
	};
	EnhancedComponent.displayName = 'componentWithValidation';
	return EnhancedComponent;
};
